__turbopack_context__.v({
  "activecontrol": "cc6EUa_activecontrol",
  "best": "cc6EUa_best",
  "btngroup": "cc6EUa_btngroup",
  "cardgrey": "cc6EUa_cardgrey",
  "cat": "cc6EUa_cat",
  "categorySection": "cc6EUa_categorySection",
  "control": "cc6EUa_control",
  "hero": "cc6EUa_hero",
  "productImage": "cc6EUa_productImage",
  "products": "cc6EUa_products",
  "sc": "cc6EUa_sc",
  "sections": "cc6EUa_sections",
});
